import VolumeController from './src/VolumeController'

export default VolumeController
